module.exports = __webpack_public_path__ + "static/media/normal.b163cafd.png";